import React, { Component } from 'react';
import LazyLoad from 'react-lazyload';
import Webpage from '../icons/Webpage';
import Github from '../icons/Github';

export class PortfolioItem extends Component {
	invisible = {
		position: 'absolute',
		overflow: 'hidden',
		clip: 'rect(0 0 0 0)',
		height: '1px',
		width: '1px',
		margin: '-1px',
		padding: 0,
		border: 0
	};

	render() {
		let { image, imagem, links, active, description } = this.props;

		return (
			<div className={`portfolio__item ${active ? 'grid' : ''}`}>
				<figure ref="portfolio_fig" tabIndex="0">
					<button className="overlay__close" style={{ '--text-color': '#ffffff' }}>
						✖
					</button>
					{/* <img className="portfolio__img" src={image} alt="" /> */}
					<LazyLoad offset={400} height="60vh">
						<picture className="portfolio__img">
							<source media="(max-width: 768px)" srcSet={imagem} />
							<source srcSet={image} media="(min-width: 768px)" />
							<img className="portfolio__img" src={image} alt="" />
							<div className="overlay overlay__parts" />
						</picture>
					</LazyLoad>
					<div className="middle overlay__parts">
						<div className="portfolio__links overlay__parts" style={{ '--text-color': '#ffffff' }}>
							{links &&
								links.map((link, key) => {
									let IconComp = link.icon === 'Webpage' ? <Webpage /> : <Github />;
									return (
										<a
											tabIndex={0}
											key={key}
											href={link.link}
											className="portfolio-url"
											aria-label={link.type === 'github' ? 'Visit Github Page' : 'Check Live Version'}
										>
											{/* <i className={link.icon} /> */}
											{IconComp}
										</a>
									);
								})}
						</div>
						<div>
							<figcaption>{description}</figcaption>
						</div>
					</div>
					{/* <figcaption>{description}</figcaption> */}
				</figure>
			</div>
		);
	}
}

export default PortfolioItem;



// WEBPACK FOOTER //
// ./src/components/portfolio/PortfolioItem.js